import { Action, Module, VuexModule } from 'vuex-module-decorators'
import { Loading } from '@/shared/utils/vuex-loading'
import { DELETE_POST, UPDATE_POST } from '@/business/post/store/types'
import { Api } from '@/api/api'
import { UpdatePostPayload } from '@/business/post/store/update-post-payload'
import { PostResponse } from '@/api/generated'

const STORE_NAME = 'post'

@Module({
  name: STORE_NAME,
})
export class PostModule extends VuexModule {
  public static STORE_NAME = STORE_NAME

  @Loading(DELETE_POST)
  @Action({
    commit: DELETE_POST,
    rawError: true,
  })
  deletePost(payload: { postId: number }): Promise<void> {
    return Api.Posts.deletePost({
      postId: payload.postId,
    })
  }

  @Loading(UPDATE_POST)
  @Action({
    rawError: true,
  })
  public updatePost(payload: UpdatePostPayload): Promise<PostResponse> {
    return Api.Posts.updatePost(payload)
  }
}
